module.exports = __webpack_public_path__ + "img/annonym-profil-icon.db4c9326.png";